import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";

const WithLink = ({children, multiSelect, nextRoute}) => {
  const childrenWithLink = (
    <Link to={nextRoute}>
      {children}
    </Link>
  );

  return multiSelect ? children : childrenWithLink;
};

WithLink.propTypes = {
  "children": PropTypes.node.isRequired,
  "multiSelect": PropTypes.bool.isRequired,
  "nextRoute": PropTypes.string.isRequired
};

export default class Image extends React.PureComponent {

  static propTypes = {
    "answer": PropTypes.object.isRequired,
    "isMetalImage": PropTypes.bool.isRequired,
    "label": PropTypes.element.isRequired,
    "location": PropTypes.object.isRequired,
    "multiSelect": PropTypes.bool.isRequired,
    "nextRoute": PropTypes.string.isRequired,
    "onAnswer": PropTypes.func.isRequired,
    "surveyFields": PropTypes.object.isRequired
  };

  static defaultProps = {
    "isMetalImage": false,
    "label": <div />
  };

  handleClick = () => {
    const {"answer": {surveyFields}, onAnswer} = this.props;
    onAnswer(surveyFields, this.isSelected());
  };

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleClick();
    }
  }

  isSelected = () => {
    const {
      "answer": {"surveyFields": answerFields},
      surveyFields
    } = this.props;

    /*
     * Assume true, look for any answerField that is different from
     * corresponding surveyField
     */
    return Object.keys(answerFields).reduce(
      (selected, key) => selected
        ? answerFields[key] === surveyFields[key]
        : false,
      true
    );
  };

  render () {
    const {
      answer,
      isMetalImage,
      label,
      multiSelect,
      nextRoute
    } = this.props;
    const imageUrlPrefix = "https://karat-herokuapp-com.freetls.fastly.net/s3media";

    return (
      <WithLink
        multiSelect={multiSelect}
        nextRoute={nextRoute}
      >
        <div
          className="Image"
          onClick={this.handleClick}
          onKeyDown={this.handleKeyDown}
          tabIndex="0"
        >
          <img
            alt={`Press enter for ${answer.prompt}`}
            className={this.isSelected()
              ? "color-tangerine-border"
              : "color-grey-border"}
            src={`${imageUrlPrefix}/style_survey/${answer.image}.jpg`}
            style={{"width": isMetalImage ? "100%" : "auto"}}
            title={answer.prompt}
          />
          {label}
        </div>
      </WithLink>
    );
  }
}
